import { Component, HostListener, OnInit } from '@angular/core';
import { FaviconService } from '../services/favicon/favicon.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'spe-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss'],
    standalone: false
})
export class PdfViewerComponent implements OnInit {
    pdfUrl!: string;
    public isCaixa = localStorage.getItem('BRAND-THEME') == 'cef';
    screenWidth!: number;
    screenHeight!: number;
    title: string | undefined = undefined

    constructor(
        private favIconService: FaviconService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.getScreenSize();
        this.route.queryParams.subscribe(params => {
            this.pdfUrl = params['pdf'];
            this.title = params['title']
        });

        this.setFavIcon()
    }

    @HostListener('window:resize')
    onResize() {
        this.getScreenSize();
    }

    getScreenSize() {
        this.screenWidth = window.innerWidth;
        this.screenHeight = window.innerHeight;
    }

    setFavIcon() {
        if (this.isCaixa) {
            this.favIconService.changeFavicon("assets/favicon/favicon2.png")
            if (!this.title) {
                this.favIconService.changeTitle("CAIXA - Líder em Vales-Transporte")
            } else {
                this.favIconService.changeTitle(this.title)
            }
        } else {
            this.favIconService.changeFavicon("assets/favicon/favicon1.png")
            if (!this.title) {
                this.favIconService.changeTitle("Sem Parar - Empresas")
            } else {
                this.favIconService.changeTitle(this.title)
            }
        }
    }
}